import { generateActions } from '../../utils/HttpReducerHelper';

import {
  allClients,
  client,
  assignTag,
  unassignTag,
  updateClientNote,
  updateClientManager,
  updateClientPreview,
  SET_MONITOR_STATUS_FILTERS,
  SET_MONITOR_PROPERTIES_FILTERS,
  SET_MONITOR_TAGS_FILTERS,
  REMOVE_MONITOR_FILTERS,
  SET_WIZZARD_REDIRECT_CLIENT_ID,
  CHANGE_CLIENTS_LOADING_STATE,
  SET_CLIENT_GENERATED_AT,
  SET_MONITOR_FILTER_BY_MANAGER,
  SET_MONITOR_ARCHIVED_VIEW,
} from './types';

const allClientsHTTPActions = generateActions(allClients);
const clientHTTPActions = generateActions(client);

export const requestAllClients = allClientsHTTPActions.request;
export const requestAllClientsSuccess = allClientsHTTPActions.success;
export const requestAllClientsFailure = allClientsHTTPActions.failure;

export function requestClient(id, promise) {
  return {
    type: client.request,
    id,
    promise,
  };
}

export function requestClientSuccess(id, response) {
  return {
    type: client.success,
    id,
    response,
  };
}

export function requestClientUpdateNote(entityId, note, promise) {
  return {
    type: updateClientNote.request,
    entityId,
    note,
    promise,
  };
}

export function requestClientUpdateNoteSuccess(id, response) {
  return {
    type: updateClientNote.success,
    id,
    response,
  };
}

export function requestClientUpdateManager(entityId, business, userCompanyId, promise) {
  return {
    type: updateClientManager.request,
    entityId,
    business,
    userCompanyId,
    promise,
  };
}

export function requestUpdateClientPreview(id, response) {
  return {
    type: updateClientPreview,
    id,
    response,
  };
}

export const requestClientFailure = clientHTTPActions.failure;

export function setMonitorWizzardRedirectClientId(id) {
  return {
    type: SET_WIZZARD_REDIRECT_CLIENT_ID,
    id,
  };
}

export const setMonitorFilterByManager = (user) => ({
  type: SET_MONITOR_FILTER_BY_MANAGER,
  user,
});

export const setMonitorArchivedView = (value) => ({
  type: SET_MONITOR_ARCHIVED_VIEW,
  value,
});

export const setMonitorStatusFilters = (filters) => ({
  type: SET_MONITOR_STATUS_FILTERS,
  filters,
});

export const setMonitorPropertiesFilters = (filters) => ({
  type: SET_MONITOR_PROPERTIES_FILTERS,
  filters,
});

export const setMonitorTagsFilters = (filters) => ({
  type: SET_MONITOR_TAGS_FILTERS,
  filters,
});

export const removeMonitorFilters = () => ({
  type: REMOVE_MONITOR_FILTERS,
});

export const unassignEntityTag = (entityId, tagId) => ({
  type: unassignTag,
  entityId,
  tagId,
});

export const assignEntityTag = (entityId, tagData) => ({
  type: assignTag,
  entityId,
  tagData,
});

export const changeClientsLoadingState = (loadingState) => ({
  type: CHANGE_CLIENTS_LOADING_STATE,
  loadingState,
});

export const setClientGeneratedAt = (payload) => ({
  type: SET_CLIENT_GENERATED_AT,
  payload,
});
